'use client';
import Link from 'next/link';
import styled, { keyframes } from 'styled-components';

export const StyledOnboardingIntro = styled.main`
  background: ${props => props.theme.colors.background.base};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overscroll-behavior: none;

  @media ${props => props.theme.laptop} {
    display: flex;
    align-items: center;
  }
`;

export const MobileHeader = styled.div`
  position: fixed;
  top: ${props => props.theme.spacing(4)};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  gap: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    display: none;
  }
`;
export const DesktopHeader = styled.span`
  display: none;
  @media ${props => props.theme.laptop} {
    display: flex;
    justify-content: center;
  }
`;

export const LogoLink = styled(Link)`
  border: 2px solid transparent;
  &:focus,
  &:active {
    border: 2px solid transparent;
  }
`;

export const ImageContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media ${props => props.theme.laptop} {
    position: relative;
    width: 50%;
    img {
      object-fit: cover;
    }
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;
  height: 100%;
  @media ${props => props.theme.laptop} {
    display: flex;
    img {
      height: 100vh !important;
    }
  }
`;
export const MobileImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  z-index: 2;
  display: flex;
  position: fixed;
  top: ${props => props.theme.spacing(4)};
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 75px;
  width: 100%;
  @media ${props => props.theme.laptop} {
    position: absolute;
    top: 10px;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;
export const Headline = styled.div`
  ${props => props.theme.typography[props.$typography]};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  min-width: 270px;
  text-align: center;
  margin: auto;
`;

export const BodyWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  min-height: ${props =>
    props.$minHeight ? `${props.$minHeight}px` : '321px'};
  bottom: 0;
  width: 100%;
  padding: ${props => props.theme.spacing(10, 5)};
  gap: ${props => props.theme.spacing(4)};
  border-radius: 32px 32px 0 0;
  overflow: visible;
  background-color: ${props => props.theme.colors.background.base};

  @media ${props => props.theme.laptop} {
    position: relative;
    width: 50%;
    justify-content: space-around;
    border-radius: 0;
    max-width: 365px;
    padding: 0;
    margin: auto;
    gap: ${props => props.theme.spacing(6)};
    padding-top: ${props => props.theme.spacing(20)};
    overflow: hidden;
  }
`;

export const Body = styled.p`
  ${props => props.theme.typography[props.$typography]}
  color: ${props => props.theme.colors.get(props.$fontColor)};
  text-align: center;
`;

// Discount Pop Up
const slideUp = keyframes`
  0% { transform: translateY(100%); opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  95% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(50%); opacity: 0; }
  `;

export const PopUpBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.$alignment};
  ${props => props.theme.typography.heading6};
  ${props => props.theme.fontFamily.base}
  height: 52px;
  position: absolute;
  bottom: calc(100% + ${props => props.theme.spacing(2)});
  left: 0;
  right: 0;
  margin: auto;
  width: 90%;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  padding: 16px 32px 18px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 5s ease-in forwards;
  font-size: 1rem;
  z-index: 9999;
  max-width: 350px;
  svg {
    margin-right: 10px;
  }
  @media ${props => props.theme.laptop} {
    position: absolute;
    bottom: auto;
    top: 0;
  }
`;

//Dropoff Path

export const DropoffCallout = styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.background.lightest};
  color: ${props => props.theme.colors.text.primary};
  border-radius: 24px;
  padding: ${props => props.theme.spacing(6, 4)};
  width: 100%;
  margin: auto;
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  text-align: left;
  align-items: center;

  @media ${props => props.theme.mobileL} {
    width: 360px;
  }

  &:focus-within {
    outline: 1px solid ${props => props.theme.colors.border.base};
  }
`;

export const DropoffLinkOverlay = styled(Link)`
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: inherit;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
`;

export const DropoffHeadline = styled.p`
  ${props => props.theme.typography.button};
  font-weight: 700;
  margin-top: ${props => props.theme.spacing(2)};
`;

export const DropoffBody = styled.p`
  ${props => props.theme.typography.body};
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DropoffLinkText = styled.span`
  ${props => props.theme.typography.button};
  color: ${props => props.theme.colors.get('text.link')};
  font-size: 1rem;
`;
